import LogsView from "@/components/logs/LogsView";

export default function AdminLogs() {
  return <LogsView admin />;
}
